import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useHistory} from 'react-router-dom';
import {useTable} from 'react-table';
import * as actions from '../../_redux/usersActions';
import * as columnFormatters from './column-formatters';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useUsersUIContext} from '../UsersUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";

export function UsersTable() {
  const intl = useIntl();
  const history = useHistory();
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'fullName',
      Header: intl.formatMessage({
        id: 'users-column-fullName', defaultMessage: 'Name'
      })
    },
    {
      accessor: 'agentId',
      Header: intl.formatMessage({
        id: 'users-column-agentId', defaultMessage: 'Agent Id'
      })
    },
    {
      accessor: 'createdAt',
      Header: intl.formatMessage({
        id: 'users-column-createdAt', defaultMessage: 'Agent Id'
      })
    },
    {
      accessor: 'idNumber',
      Header: intl.formatMessage({
        id: 'users-column-idNumber', defaultMessage: 'Id number'
      })
    },
    {
      accessor: 'tamalId',
      Header: intl.formatMessage({
        id: 'users-column-shiklulitId', defaultMessage: 'Shiklulit Id'
      })
    },
    {
      accessor: 'address',
      Header: intl.formatMessage({
        id: 'users-column-address', defaultMessage: 'Address'
      })
    },
    {
      accessor: 'phone',
      Header: intl.formatMessage({
        id: 'users-column-phone', defaultMessage: 'Phone'
      })
    },
    {
      accessor: 'button',
      Header: intl.formatMessage({
        id: 'users-column-button', defaultMessage: 'Actions'
      })
    },
  ], [intl]);
  const data = useMemo(() => [
    ...tableRows.map((item, index) => {
      return {
        fullName: columnFormatters.UserNameAndEmailColumnFormatter(null, item, index, {history}),
        agentId: commonColumnFormatters.BoldColumnFormatter(item.agentId),
        createdAt: commonColumnFormatters.DateColumnFormatter(item.createdAt),
        idNumber: commonColumnFormatters.BoldColumnFormatter(item.idNumber),
        tamalId: commonColumnFormatters.BoldColumnFormatter(item.tamalId),
        address: columnFormatters.AddressColumnFormatter(null, item),
        phone: commonColumnFormatters.BoldColumnFormatter(item.phone),
        button: columnFormatters.ActionsColumnFormatter(null, item, index, {history}),
      };
    })
  ], [tableRows, history]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'users',
    UIContext: useUsersUIContext(),
    getNewEntities: actions.getUsers,
    getNextEntities: actions.getNextUsers,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'users-table'}
    />
  );
}
